import { trainingVersionRepository } from "../../../providers/repositories/trainingVersionRepository";
import { TrainingVersionFormData } from "../entities/TrainingVersion";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const addUpdateTrainingVersionUseCase = {
  async exec(
    data: TrainingVersionFormData,
    id: number | string | null,
  ): Promise<boolean> {
    try {
      await trainingVersionRepository.addUpdate(data, id);

      if (id) {
        toast.success(t("action.updateSuccess"));
      }
      return true;
    } catch (error) {
      Logger.error("addUpdateTrainingVersionUseCase", error);
      toast.error(t("action.updateError"));
    }
    return false;
  },
};
